import { tokens } from '@ekelhaft-tools/eitelkeit/tokens';

export type DeploymentStatus =
  | 'pending'
  | 'running'
  | 'succeeded'
  | 'failed'
  | 'cancelled'
  | 'rolled_back'
  | 'skipped';

/**
 * Get EITELKEIT token color for deployment status
 */
export function getDeploymentStatusColor(status: DeploymentStatus): string {
  switch (status) {
    case 'succeeded':
      return tokens.colors.mint;
    case 'running':
      return tokens.colors.warning;
    case 'pending':
      return tokens.colors.textMuted;
    case 'failed':
      return tokens.colors.danger;
    case 'cancelled':
      return tokens.colors.textMuted;
    case 'rolled_back':
      return tokens.colors.warning;
    case 'skipped':
      return tokens.colors.textSecondary;
  }
}

/**
 * Get EITELKEIT Badge variant for deployment status
 */
export function getDeploymentStatusVariant(
  status: DeploymentStatus,
): 'mint' | 'info' | 'success' | 'danger' | 'warning' {
  switch (status) {
    case 'succeeded':
      return 'success';
    case 'running':
      return 'info';
    case 'pending':
      return 'mint';
    case 'failed':
      return 'danger';
    case 'cancelled':
      return 'warning';
    case 'rolled_back':
      return 'danger';
    case 'skipped':
      return 'warning';
  }
}
